export default "__VITE_ASSET__1354112f__"